import { z } from 'zod'

/**
 * The zip format this build reads and writes (spec §3.1). An importer that meets a
 * different value refuses by name rather than half-importing, so the schema parses the
 * number and the comparison is the importer's — not zod's.
 */
export const SPACE_EXPORT_FORMAT_VERSION = 1

/**
 * The kernel schema `tunasong.db` was written against (spec §3.1). Recorded so L6's
 * upgrade path can migrate an imported database exactly as it migrates a long-lived
 * local one — no second mechanism.
 */
export const KERNEL_SCHEMA_VERSION = 1

export const spaceExportMissingSchema = z.object({
  entityId: z.string(),
  filename: z.string(),
  reason: z.string(),
})
export type SpaceExportMissing = z.infer<typeof spaceExportMissingSchema>

export const spaceExportCountsSchema = z.object({
  entities: z.number().int().nonnegative(),
  edges: z.number().int().nonnegative(),
  docs: z.number().int().nonnegative(),
  blobs: z.number().int().nonnegative(),
})

export const spaceExportManifestSchema = z.object({
  formatVersion: z.number().int(),
  kind: z.literal('space'),
  exportedAt: z.iso.datetime(),
  /** The exporting user. The kernel adopts this identity on import (spec §5.2) */
  sourceUserId: z.string(),
  rootEntityId: z.string(),
  counts: spaceExportCountsSchema,
  kernelSchemaVersion: z.number().int(),
  missing: z
    .array(spaceExportMissingSchema)
    .describe('Files an entity references that could not be fetched at export time (spec §7)')
    .optional(),
})
export type SpaceExportManifest = z.infer<typeof spaceExportManifestSchema>
